if(typeof FN == 'undefined') FN = {};

FN.contentDownload = {
  selectors: {
    'downloadButtonClass': 'content-download-link',
    'contentDownloadOverlayBaseClass': 'overlay__container--content-download'
  },
  
  
  init: function() {
    document.addEventListener('click', function(event){
      var clickedElement = event.target.closest('.' + FN.contentDownload.selectors.downloadButtonClass);
      if (!clickedElement) return;
      event.preventDefault();
      FN.contentDownload.startDownload(clickedElement);
      FN.contentDownload.showPopup();
    });
  },
  
  
  startDownload: function(clickedElement){
    if(!clickedElement || clickedElement.tagName !== 'A') return;
    
    var url = clickedElement.getAttribute('href');
    var iFrame = document.createElement('iframe');
    iFrame.style.display = 'none';
    iFrame.setAttribute('src', url);
    document.body.appendChild(iFrame);
  },
  
  
  showPopup: function() {
    var baseElementSelector = '.' + FN.contentDownload.selectors.contentDownloadOverlayBaseClass;
    FN.overlay.init({ baseElement: baseElementSelector });
  }
};




document.addEventListener('DOMContentLoaded', function(){
  FN.contentDownload.init();
});
